import { render, staticRenderFns } from "./NotesAnalytics.vue?vue&type=template&id=6792e186&scoped=true"
import script from "./NotesAnalytics.vue?vue&type=script&lang=js"
export * from "./NotesAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6792e186",
  null
  
)

export default component.exports